module.exports = __webpack_public_path__ + "img/trinidad_and_tobago.2cd49c3.webp";